<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="cus-group"></i>
                    Relationships
                </template>
                <b-dropdown-item @click="displayRelationships()">
                    <i class="cus-group"></i>View Relationships
                </b-dropdown-item>
                <div class="dropdown-divider"></div>
                <b-dropdown-item
                    v-if="_hasAccess('client.patient.add') && statusActive"
                    @click.stop="openModalNewRelationship"
                >
                    <i class="cus-add"></i> New Relationship
                </b-dropdown-item>
                <template v-if="isClientHasEmail">
                    <div class="dropdown-divider"></div>
                    <b-dropdown-item @click.stop="exportPatient">
                        <i class="cus-folder-go"></i> Export Patients
                    </b-dropdown-item>
                </template>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <list-relationships :key="keyview" />
        </b-card-text>
    </b-tab>
</template>
<script>
import ListRelationships from "@/components/client-relationships/relationship-list";

export default {
    components: {
        ListRelationships
    },
    computed: {
        clientDetails() {
            return this.$store.getters["client/clientDetails"];
        },
        statusActive() {
            return this.$store.getters["client/statusActive"];
        },
        isClientHasEmail() {
            return Boolean(this.clientDetails?.email);
        }
    },
    data() {
        return {
            keyview: 0
        };
    },
    methods: {
        openModalNewRelationship() {
            this.$parent.$parent.$refs.modalNewRelationship.open();
        },
        displayRelationships() {
            this.keyview++;
        },
        exportPatient() {
            this.$emit("export-patient");
        }
    }
};
</script>
